export default "__VITE_ASSET__DGV7VQzc__"